<script setup>
import { useAppStore } from "@/store/app";

const homeUrl = process.env.VUE_APP_NLX_SERVER
const app = useAppStore()
</script>


<template>
  <a :href="homeUrl" :title="app.appTitle">
    <img :src="app.appIcon" alt="Logo" class="af-app-logo" />
  </a>
</template>
